import styled from 'styled-components'

export const SearchContainer = styled.div`
  width: 100%;
  max-width: 565px;
  display: flex;
  position: relative;
  align-items: center;

  .search-icon {
    position: absolute;
    height: 17px;
    width: 17px;
    margin-left: 3%;
  }
  .search {
    border: 1px solid #202328;
    border-radius: 100px;
    height: 56px;
    width: 100%;
    padding-left: 55px;
  }
`
